import React from 'react';

export const FindMembers: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg viewBox="0 0 20 21" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#697180">
      <path
        strokeLinecap="round"
        d="M12.037 12.113a.39.39 0 0 0 .39-.39v-.695c0-.101-.067-.202-.134-.235-1.008-.404-2.15-.908-2.25-1.243v-.337c.201-.235.368-.537.47-.907.234-.168.302-.537.1-.773v-.738c0-.773-.403-1.311-1.344-1.311-.907 0-1.343.538-1.343 1.311v.738c-.202.236-.134.605.1.773.101.37.27.672.471.907v.337c-.135.335-1.277.839-2.285 1.243-.1.033-.134.134-.134.235v.695c0 .216.175.39.39.39h5.569zM14.396 14.396l3.54 3.54"
      />
      <path d="M14.336 4.17A7.19 7.19 0 0 1 4.17 14.336 7.19 7.19 0 0 1 14.336 4.169z" />
    </g>
  </svg>
);
